var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricing1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 515,
    viewBox: "0 0 201 515",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_65_20310)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_65_20310",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -1092,
    y: 0,
    width: 1294,
    height: 515
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1092,
    width: 1293.25,
    height: 514.5,
    fill: "#270F3A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_65_20310)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.113 999.918C352.106 935.844 11.71 792.961 29.2069 664.44C43.1598 561.95 198.067 603.841 232.965 489.728C253.048 424.055 154.213 305.723 4.06665 219.705",
    stroke: "#FF8C66",
    strokeWidth: 8,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_65_20310"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201,
    height: 515,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing1);
export default __webpack_public_path__ + "static/media/pricing_1.fe173f889020adde5f198afa804de20c.svg";
export { ForwardRef as ReactComponent };